import { Link } from "react-router-dom";
import aimLogo from "../../assets/aim.png";
import "./home.scss";
import gunReload from "../../assets/sounds/shotgun-reload.mp3";
import { useEffect, useRef, useState } from "react";
import challenge from "../../assets/thumbnails/challenge.png";
import precision from "../../assets/thumbnails/precision.png";
import response from "../../assets/thumbnails/response.png";
import movingTargets from "../../assets/thumbnails/moving_targets.png";
import doubleshot from "../../assets/thumbnails/doubleshot.png";
import targetTracking from "../../assets/thumbnails/target_tracking.png";
import training from "../../assets/thumbnails/training.png";
import challengeHover from "../../assets/thumbnails/challengeHover.png";
import doubleshotHover from "../../assets/thumbnails/doubleshotHover.png";
import precisionHover from "../../assets/thumbnails/precisionHover.png";
import responseHover from "../../assets/thumbnails/responseHover.png";
import movingTargetsHover from "../../assets/thumbnails/movingTargetsHover.png";
import targetTrackingHover from "../../assets/thumbnails/targetTrackingHover.png";
import { Helmet } from "react-helmet";
// import { useThemeActions, useThemeState } from "../../context/themeContext";
import { Modal } from "antd";

const ModesLink = (props) => {
  var img = "";
  if (props.url === "custom-challenge") {
    img = challenge;
  } else if (props.url === "precision") {
    img = precision;
  } else if (props.url === "response") {
    img = response;
  } else if (props.url === "doubleshot") {
    img = doubleshot;
  } else if (props.url === "target-tracking") {
    img = targetTracking;
  } else if (props.url === "moving-targets") {
    img = movingTargets;
  }
  return (
    <div className="w-100 m-2 row mt-4 mode-container bg-animate">
      <div
        className="m-0 p-2 px-4 order-md-1 order-2"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <Link to={`/${props.url}`}>
          <img
            src={img}
            onMouseOver={(e) => {
              if (props.url === "custom-challenge") {
                e.currentTarget.src = challengeHover;
              } else if (props.url === "precision") {
                e.currentTarget.src = precisionHover;
              } else if (props.url === "response") {
                e.currentTarget.src = responseHover;
              } else if (props.url === "doubleshot") {
                e.currentTarget.src = doubleshotHover;
              } else if (props.url === "target-tracking") {
                e.currentTarget.src = targetTrackingHover;
              } else if (props.url === "moving-targets") {
                e.currentTarget.src = movingTargetsHover;
              }
            }}
            onMouseOut={(e) => {
              if (props.url === "custom-challenge") {
                e.currentTarget.src = challenge;
              } else if (props.url === "precision") {
                e.currentTarget.src = precision;
              } else if (props.url === "response") {
                e.currentTarget.src = response;
              } else if (props.url === "doubleshot") {
                e.currentTarget.src = doubleshot;
              } else if (props.url === "target-tracking") {
                e.currentTarget.src = targetTracking;
              } else if (props.url === "moving-targets") {
                e.currentTarget.src = movingTargets;
              }
            }}
            style={{
              width: "100%",
              height: "100%",
            }}
            alt="thumbnail_image"
            unselectable="on"
          ></img>
        </Link>
      </div>
    </div>
  );
};

const ComingSoonModal = (props) => {
  return (
    <Modal
      centered
      width="min-content"
      title=""
      visible={props.isComingSoonVis}
      onCancel={() => {
        props.setIsComingSoonVis(false);
      }}
      footer={null}
      className="coming-soon-modal"
    >
      <p>Coming soon...</p>
    </Modal>
  );
};

const Home = (props) => {
  const gunReloadRef = useRef(null);
  const [isLogoHover, setIsLogoHover] = useState(false);
  const [isComingSoonVis, setIsComingSoonVis] = useState(false);
  useEffect(() => {
    if (isLogoHover && gunReloadRef && gunReloadRef.current) {
      console.log("hello");
      gunReloadRef.current.pause();
      gunReloadRef.current.currentTime = 0;
      gunReloadRef.current.play();
    }
  }, [isLogoHover]);
  return (
    <div className="d-flex flex-column justify-content-center align-items-center home bg-animate">
      <Helmet>
        <title>Quick Play Aim Training Modes | OG Aim Trainer</title>
        <meta property="og:title" content="Quick Play Aim training Modes" />
        <meta
          name="description"
          content="Boost your FPS shooting skills with the four different challenges offered by our Aim trainer. From moving targets to creating your custom challenges. OG Aim trainer has everything."
        />
        <meta
          property="og:description"
          content="Boost your FPS shooting skills with the four different challenges offered by our Aim trainer. From moving targets to creating your custom challenges. OG Aim trainer has everything."
        />
      </Helmet>
      <ComingSoonModal
        isComingSoonVis={isComingSoonVis}
        setIsComingSoonVis={setIsComingSoonVis}
      />
      <audio ref={gunReloadRef} src={gunReload} />

      <div className="d-flex justify-content-between align-items-center w-100 container mt-3">
        <div
          className="d-flex justify-content-start align-items-center w-100 mt-3"
          style={{ fontSize: "x-large", fontWeight: "700" }}
        >
          <a href="https://aimtrainer.com/" target={"_blank"} rel="noreferrer">
            <img
              src={aimLogo}
              className="mr-10 logo"
              onMouseEnter={() => {
                setIsLogoHover(true);
              }}
              onMouseLeave={() => {
                setIsLogoHover(false);
              }}
              alt="aimlogo"
              unselectable="on"
            />
          </a>
        </div>
      </div>
      <div
        className="d-flex flex-column justify-content-center align-items-center w-100 mt-5 container"
        style={{ zIndex: 2 }}
      >
        <img
          src={training}
          alt="training"
          width={400}
          style={{ pointerEvents: "none" }}
        ></img>
      </div>
      <div className="d-flex flex-column justify-content-center align-items-center w-100 container">
        <div
          className="w-100 d-flex flex-row justify-content-center align-items-start mt-1"
          style={{ fontSize: "x-large", fontWeight: "700", color: "white" }}
        >
          <div
            className="d-flex flex-row align-items-start w-100"
            style={{ textAlign: "start" }}
          >
            <ModesLink
              key={1}
              delay={"0s"}
              url="custom-challenge"
              title="CHALLENGE"
              desrciption="In this mode you can practice everything including response time |
              precision | accuracy | speed | with and without moving targets"
            />

            {/* <ModesLink
              key={2}
              delay={"0.1s"}
              url="gravity"
              title="GRAVITY"
              desrciption="In this mode you can practice your aim with targets 
              being thrown up with the effect of gravity on them,
              and improve everything including response time,
              precision, accuracy, speed, with option to reverse the gravity also"
            /> */}

            <ModesLink
              key={2}
              delay={"0.3s"}
              url="doubleshot"
              title="DOUBLESHOT"
              desrciption="In this mode you can practice and improve your response time"
            />

            <ModesLink
              key={3}
              delay={"0.2s"}
              url="precision"
              title="PRECISION"
              desrciption="In this mode you can practice your precision 
              which can help you improve your headshots in the game in this mode the targets are smaller in size"
            />
          </div>
        </div>
      </div>

      <div className="d-flex flex-column justify-content-center align-items-center w-100 container mb-3">
        <div
          className="w-100 d-flex flex-row justify-content-center align-items-start"
          style={{ fontSize: "x-large", fontWeight: "700", color: "white" }}
        >
          <div
            className="d-flex flex-row align-items-start w-100"
            style={{ textAlign: "start" }}
          >
            <ModesLink key={4} delay={"0.3s"} url="response" title="RESPONSE" />
            <ModesLink
              key={5}
              delay={"0.3s"}
              url="moving-targets"
              title="MOVING TARGETS"
            />
            <ModesLink
              key={6}
              delay={"0.3s"}
              url="target-tracking"
              title="TARGET TRACKING"
            />
          </div>
        </div>

        <div
          className="d-flex flex-cloumn justify-content-center mt-5 pt-3"
          style={{ fontSize: "large", color: "white" }}
        >
          <a
            href="https://aimtrainer.com/"
            target={"_blank"}
            className="footer-link"
            rel="noreferrer"
          >
            OG AIM TRAINER&nbsp;
          </a>
          <span style={{ fontFamily: "sans-serif" }}>©️&nbsp;</span> All rights
          reserved
        </div>
      </div>
    </div>
  );
};

export default Home;
